import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["includedAttributes", "excludedAttributes", "transformItems", "translations"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { useClearRefinements } from 'react-instantsearch-hooks';
import { ClearRefinements as ClearRefinementsUiComponent } from "../ui/ClearRefinements.js";
export function ClearRefinements(_ref) {
  var includedAttributes = _ref.includedAttributes,
    excludedAttributes = _ref.excludedAttributes,
    transformItems = _ref.transformItems,
    translations = _ref.translations,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useClearRefinements = useClearRefinements({
      includedAttributes: includedAttributes,
      excludedAttributes: excludedAttributes,
      transformItems: transformItems
    }, {
      $$widgetType: 'ais.clearRefinements'
    }),
    canRefine = _useClearRefinements.canRefine,
    refine = _useClearRefinements.refine;
  var uiProps = {
    onClick: refine,
    disabled: !canRefine,
    translations: _objectSpread({
      resetButtonText: 'Clear refinements'
    }, translations)
  };
  return /*#__PURE__*/React.createElement(ClearRefinementsUiComponent, _extends({}, props, uiProps));
}